import { AdvertiserUsersList } from '@anytag/shared-organisms';
import { useAdvertiserDetailsContext } from './advertiser-details-context';

export const AdvertiserUsers = () => {
  const { advertiser } = useAdvertiserDetailsContext();

  return (
    <div data-card-connect-top>
      <AdvertiserUsersList advertiserId={advertiser.id} />
    </div>
  );
};
